<template>
  <div>
    <v-dialog
      width="1000"
      v-model="modal"
      scrollable
      >
      <v-card>
        <v-card-title
          style="width: 800px"
          class="mx-auto"
          >
          Crear pago

          <v-spacer></v-spacer>

          <v-btn
            @click.stop="modal = false"
            icon
            >
            <v-icon>
              mdi-close
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text
          class="pa-0"
          >
          <create
            :id="contract.id"
            :key="counter"
            @created="reload"
            dialog
            ></create>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-card
      color="background"
      flat>
      <v-card-subtitle
        class="px-0 pb-0 caption">
        NUEVO CONTRATO
      </v-card-subtitle>

      <v-card-title
        class="px-0 pt-0 pb-5">
        Impuestos y pagos
      </v-card-title>

      <v-card-subtitle
        class="px-0 pb-1 caption">
      </v-card-subtitle>
    </v-card>

    <v-card
      :key="counter"
      :loading="loading"
      :disabled="loading"
      class="fill-width">
      <v-card-text>
        <template
          v-for="tax in taxes"
          >
          <tax
            :tax="tax"
            @reload="fetchTaxes"
            class="mb-3"
            ></tax>
        </template>

        <div
          class="text-right"
          >
          <v-btn
            color="blue"
            class="rounded-lg"
            outlined
            @click="modal = true"
            >
            Nuevo pago
          </v-btn>
        </div>
      </v-card-text>
    </v-card>

    <div
      class="pt-6 text-right">
      <v-btn
        @click="$router.go(-1)"
        text>
        Cerrar y continuar luego
      </v-btn>
      <v-btn
        color="primary"
        @click="nextStep">
        Siguiente
      </v-btn>
    </div>
  </div>
</template>

<script>
import Tax from '@/components/taxes/Tax'
import Create from '@/components/taxes/Create'

import { Taxes } from '@/graphql/queries/tax'

export default {
  data: () => ({
    valid: true,
    loading: false,
    taxes: [],
    counter: 0,
    modal: false
  }),

  props: {
    contract: {
      type: Object,
      required: true
    }
  },

  created () {
    this.fetchTaxes ()
  },

  methods: {
    fetchTaxes () {
      this.$apollo.query({
        query: Taxes,
        variables: {
          id: this.contract.id
        },
        fetchPolicy: 'no-cache'
      }).then ( res => {
        this.taxes = res.data.taxes
        this.counter += 1
      }) 
    },

    nextStep () {
      // this.$emit('continue', this.fetchedContract)
      // if (this.valid) this.valid = this.$refs.form.validate()    

      if (this.valid) {
        this.$emit('continue', this.contract)
      } 
    },

    reload () {
      this.fetchTaxes ()
      this.modal = false
    }
  },

  components: {
    Tax,
    Create
  }
}
</script>
